import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router';

import { appointmentIsCancelable } from '../../utils/helpers';
import WithToggle from '../../hoc/WithToggle';
import { getAppointmentStart, getBarberAdvanceCancelMins, getCanCustomerCancel } from '../selectors';
import RescheduleLink from '../components/RescheduleLink';

const RescheduleLinkContainer = compose(
  withRouter,
  connect(state => ({
    isReschedulable: appointmentIsCancelable(
      getAppointmentStart(state),
      getBarberAdvanceCancelMins(state)
    ) && getCanCustomerCancel(state),
  })),
  WithToggle,
  withProps((props) => {
    if (!props.isReschedulable) {
      return {
        onClick: props.on,
        rescheduleLink: null,
      };
    }
    return {
      rescheduleLink: `/view-reservation/${props.params.appointmentId}/reschedule`,
    };
  }),
)(RescheduleLink);

export default RescheduleLinkContainer;



// WEBPACK FOOTER //
// ./src/app/reservation/containers/RescheduleLink.js